<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <trend-chart ref="chartInstance"
                     class="widget-contents-chart"
                     :grid="{ left: '55px', right: '1%'}"
                     :data="widgetData"
                     :x-axis="xAxis"
                     :y-axis="yAxis"
                     :series="series"
                     :tooltip="tooltip"
                     :zoom="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'

  // 차트 컴포넌트
  import {top10Color} from '~/utils/charts'

  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'

  // 스토어 헬퍼 객체
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetSslVpnTraffic',
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 2,
        self: this,
        title: 'widgetSslVpnTraffic',
        isLock: false,
        isMove: true,
        isResize: true,
        isRefresh: true,
        eventBus: true,
        deviceType: [20],
        restData: {
          result: [],
          unit_time: ''
        },
        allUpdate: false,
        widgetData: [],
        timerValue: 10000,
        timerObject: null,
        lastEndTime: '',
        selectOption: 'day',
        series: [
          {id: 'sslvpnTrafficIn', type: 'line', name: 'In', smooth: 0.6, valueYField: 'in', lineStyle: {width: 1}, areaStyle: {color: top10Color[0]}, symbol: 'circle', showSymbol: false, triggerLineEvent: true},
          {id: 'sslvpnTrafficOut', type: 'line', name: 'Out', smooth: 0.6, valueYField: 'out', lineStyle: {width: 1}, areaStyle: {color: top10Color[1]}, symbol: 'circle', showSymbol: false, triggerLineEvent: true}
        ],
        xAxisRawData: {
          type: 'time',
          axisLine: {onZero: true},
          axisLabel: {
            formatter: '{HH}:{mm}:{ss}  ',
            hideOverlap: true
          }
        },
        yAxisRawData: [
          {
            name: 'In',
            max: 1,
            min: -1,
            type: 'value',
            position: 'left',
            axisLabel: {
              formatter: value => this.bpsConverter(Math.abs(value))
            },
            nameLocation: 'center',
            nameRotate: 0,
            nameGap: 80,
            nameTextStyle: {
              verticalAlign: 'bottom',
              lineHeight: this.isMaximumWidget ? 400 : 80
            }
          },
          {
            name: 'Out',
            type: 'value',
            position: 'left',
            nameLocation: 'center',
            nameRotate: 0,
            nameGap: 80,
            nameTextStyle: {
              verticalAlign: 'top',
              lineHeight: this.isMaximumWidget ? 400 : 80
            }
          }
        ],
        // TAMS
        autoAlignTimer: void 0
      }
    },
    computed: {
      xAxis: {
        get () {
          return this.xAxisRawData
        },
        set (options) {
          this.xAxisRawData = options
        }
      },
      yAxis: {
        get () {
          return this.yAxisRawData
        },
        set (options) {
          this.yAxisRawData = options
        }
      },
      tooltip () {
        return {
          axisPointer: {type: 'line'},
          formatter: (params) => {
            const dictLabelName = {
              'sslvpnTrafficIn': 'In',
              'sslvpnTrafficOut': 'Out'
            }
            let resFormat = `<b>${params[0].axisValueLabel.split(' ')[1]}</b><br>`
            for (let i = 0, max = params.length; i < max; i++) {
              const traffic = Math.abs(params[i].value[1])
              const seriesName = _.get(dictLabelName, [params[i].seriesId], '')
              resFormat += `${params[i].marker}${seriesName} : <b>${this.bpsConverter(traffic)}</b><br>`
            }
            return resFormat
          }
        }
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {
      // 타이머 객체 생성
      // this.timerObject = setInterval(this.getWidgetContentsData, this.timerValue)
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // TAMS
      setYAxisMaxValue () {
        const chart = this.$refs.chartInstance
        const {dataMax, dataMin} = chart.yAxis[0].getExtremes()
        let allMaxValue = (dataMax > Math.abs(dataMin)) ? dataMax : Math.abs(dataMin)
        allMaxValue = (allMaxValue === 0) ? 100 : allMaxValue * 1.1

        chart.yAxis[0].update({
          min: -allMaxValue,
          max: allMaxValue
        })
      },
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        const contentsOptions = {
          widgetType: 'ssl_vpn_traffic_trend'
        }
        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        // 요청 전 차트 업데이트 처리지정
        // this.allUpdate = init

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams && extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }

        // API 호출
        const {code, result} = await this.getWidgetData(contentsOptions)

        // 마지막 시간 저장 (14:04:59 저장)
        // this.lastEndTime = eTime

        // Series 데이터 구성
        // if (code === 'ok' && result.result.length > 0) {
        if (code === 'ok' && _.size(result.result) > 0) {
          this.restData = result

          const sslVpnTrafficIn = [], sslVpnTrafficOut = []
          let maxVal = 0

          for (const vpnTraffic of this.restData.result) {
            maxVal = Math.max(maxVal, vpnTraffic.in_bps)
            maxVal = Math.max(maxVal, Math.abs(vpnTraffic.out_bps))

            sslVpnTrafficIn.push([vpnTraffic.time, vpnTraffic.in_bps])
            sslVpnTrafficOut.push([vpnTraffic.time, vpnTraffic.out_bps])
          }

          this.yAxis[0].max = maxVal + (maxVal * 0.3) || 1
          this.yAxis[0].min = -maxVal - (maxVal * 0.3) || -1

          this.widgetData = [sslVpnTrafficIn, sslVpnTrafficOut]
        } else {
          // TAMS - All update 기준
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        // Progress 출력 여부
        this.showProgress(false)
        // this.autoAlignTimer = setTimeout(() => {
        //   if (typeof self.$refs.chartInstance !== 'undefined') {
        //     self.setYAxisMaxValue()
        //   }
        // }, 1000)
      }
    },
    watch: {}
  }
</script>
<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .widget-contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
  }

  .widget-contents-option {
    right: 0;
    z-index: 10;
    display: flex;
    position: absolute;
    padding-top: 5px;
    padding-right: 5px;
  }

  .widget-contents-option select {
    width: 70px;
    height: 25px;
    font-size: 10pt;
  }

  .widget-contents-chart {
    flex-grow: 1;
  }
</style>
